import { ReceiptTypeEnum } from "@prostocheck/shared";

/**
 * `CheckDocSubType` as the `Documents` command spells it — a name, unlike the
 * numeric `<DOCSUBTYPE>` inside the XML.
 */
export const RECEIPT_TYPE_BY_SUB_TYPE_NAME: Record<string, ReceiptTypeEnum> = {
  CheckGoods: ReceiptTypeEnum.Sale,
  CheckReturn: ReceiptTypeEnum.Return,
  ServiceDeposit: ReceiptTypeEnum.Service,
  AdditionalDeposit: ReceiptTypeEnum.Service,
  ServiceIssue: ReceiptTypeEnum.Service,
  CheckStorno: ReceiptTypeEnum.Return,
};

/**
 * `CheckDocType` values that represent an actual transaction. The rest —
 * OpenShift, CloseShift, OfflineBegin, OfflineEnd — are technical documents
 * that share the `Check` class and must not appear in a receipts list.
 */
export const TRANSACTION_DOC_TYPES = [
  "SaleGoods",
  "TransferFunds",
  "CurrencyExchange",
  "CashWithdrawal",
];
